import React from 'react';
import { isStartPage } from '../types/pages.ts';
import { StartPage } from '../pages/StartPage.tsx';
import useExpandedPage from '../hooks/useExpandedContent.ts';
import "../../../../../scss/components/redesign/main.css";
const ReactRoot = ({ pageId }) => {
    const { results } = useExpandedPage(pageId);
    if (!results) {
        return null;
    }
    if (isStartPage(results)) {
        return React.createElement(StartPage, { content: results });
    }
};
export default ReactRoot;
